<template>
    <div class="container">
        <div class="content">
            <!-- <div>
                <a href="">网站地图</a>
                <span>|</span>
                <a href="">网友留言</a>
            </div> -->
            <div>导航链接:
                <a href="">首页</a>
                <a href="#">成绩查询</a>
                <a href="#" @click="toSubmit">报名方式</a>
                <a href="#" @click="toMedia">媒体报道</a>
            </div>
            <!-- 联系 -->
            <div class="contact">
                <div>
                    <img src="../../assets/images/phone.png" alt="">
                    &nbsp;010—81280083
                </div>
                <div>
                    <img class="qrcode" src="../../assets/images/qrcode.png" alt="">
                </div>
                <!-- <div>
                    <img src="../../assets/images/email.png" alt="">
                    &nbsp;sxhm1991@sxhm.com
                </div>
                <div>
                    <img src="../../assets/images/position.png" alt="">
                    中国·陕西·西安市小寨东路91号
                </div> -->
            </div>
            <!-- 备案号 -->
            <div class="record">
                <div>2025 北京立于学有限公司版权所有 Al Rights Reserved. </div>
                <div>京ICP备2023019159号</div>
                <!-- <div>陕公网安备 61011302001384号</div> -->
            </div>
            <div>
                网站建设：北京立于学有限公司
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Footer',
    methods: {
        toSubmit() {
            this.$router.push('/submit');
        },
        toMedia() {
            this.$router.push('/media');
        },
    }
}
</script>

<style scoped>
.container {
    width: 100%;
    height: 100%;
    font-size: 20px !important;
    display: flex;
    justify-content: center;
    align-items: center;
}

.content {
    width: 80vw;
    height: 80%;
    /* background-color: aqua; */
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-direction: column;
}

a {
    color: #333;
    margin: 0 20px;
}

.contact {
    width: 50%;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
}

.contact div {
    display: flex;
    align-items: center;
}

.contact div>img {
    width: 2vw;
    height: 2vw;

}

.contact div:last-child>img {
    width: 8vw;
    height: 8vw;

}

.record {
    width: 80%;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
}

/* 小屏幕/手机 */
@media screen and (max-width: 960px) {
    .container {
        font-size: 14px !important;
    }

    .content {
        width: 90vw;
    }

    a {
        margin: 0 10px;
    }

    .contact {
        width: 70%;
    }

    .contact div>img {
        width: 14px;
        height: 14px;
    }

    .contact div:last-child>img {
        width: 60px;
        height: 60px;

    }

    .record {
        width: 80%;
    }

}
</style>